import React, { useEffect, useState,} from 'react'
import '../styles/program.scss'
import _, { forEach, groupBy, includes } from 'lodash'
import DatePickerContainer from '../../datepicker/DatePickerContainer'
//import CONSTANTS from '../movielist-constants'
import xml2js from '../../../lib/xml-to-js';
import DayPicker from 'react-day-picker';
import moment from 'moment'
//import sortIcon from './images/sort-icon.png'
//import check from "./images/check-mark.svg";
//import { ROUTES } from '../navigation/route-constants'
//import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom'
import downarrow from '.././images/down-arrow-backup-2-svgrepo-com (1).svg'
//import check from "./images/check-mark.svg";
//import checkIcon from "./images/check-mark.svg";
import Region from './Region';
import Cinema from './Cinema';
import Dates from './Dates';
import Films from './Films'
//import Sorting from './Sorting';
import LOCALES from '../../overlays/OverlayLocales'
//import { appHeightChanged } from '../../../actions/app-actions'

import { useLocation } from "react-router-dom";
import LOCALE from '../../datepicker/DatePickerLocale'
import ShowtimeProgram from './ShowtimeProgram';



export default function Program({ allMovies, allEvents, allOrganizers, locations, ageCensor, allEventsTypes, appHeightChanged, allMovieBases, iframeId, backTo, site_type }) {
    const location = useLocation();
    sessionStorage.removeItem('back_to')
    const history = useHistory();
    let sorting = [
        {
            id: 0,
            name: 'Alfabetisk sorteret'
        },
        {
            id: 1,
            name: 'Mest solgte'
        },
        {
            id: 2,
            name: 'Mest programlagte'
        },
        {
            id: 3,
            name: 'Nyeste'
        },
    ]
   

    const [showCalendar, setShowCalendar] = useState(false)
    const [selectedMovieId, setSelectedMovieId] = useState('')
    const [chosenRegion, setChosenRegion] = useState([]);
    const [chosenCinema, setChosenCinema] = useState([]);
    const [noFilmError, setNoFilmError] = useState([]);
    const [calendarDate, setCalendarDate] = useState(new Date());

    const [selectedDate, setSelectedDate] = useState(moment().format('DD-MM-YYYY'))
    const [selected, setSelected] = useState(1);

    const [filteredEvents, setFilteredEvents] = useState([])

    const [isOpen, setIsOpen] = useState(false);
    const [sortedBy, setSortedBy] = useState(localStorage.getItem('sortedby') ? localStorage.getItem('sortedby')  : 'Mest programlagte');
    const [sortID, setSortID] = useState(localStorage.getItem('sort_id') ? localStorage.getItem('sort_id') :  2)
    const [cinemaID, setCinemaID] = useState(0)
    const [orgsPerRegion, setOrgPerRegion] = useState([])
    const [resetCinema, setResetCinema] = useState(false)
    const [regarr, setRegarr] = useState(localStorage.getItem('reg_arr') ? localStorage.getItem('reg_arr').split(',') : [])
    // const [datearr, setDatearr] = useState([])
    const [moviearr, setMoviearr] = useState([])
    const [cinemaarr, setCinemaarr] = useState(localStorage.getItem('cinema_arr') ? localStorage.getItem('cinema_arr').split(',') : [])
    const [cinemaIds, setCinemaIds] = useState([])
    const [sortedEventList, setSortedEventList] = useState([{}])
    const [movietoday, setMovietoday] = useState([{}])
    const [sortedEvents, setSortedEvents] = useState([])
    let evs = []
    let ev = []

    
   // filtering cinema ids according to cinema name
    useEffect(() => {
        setCinemaIds(cinemaarr.map(cinema => allOrganizers.find(o => o.name === cinema)._no))
   }, [cinemaarr])

  
    // ----------Calculating MOST PROGRAMMED MOVIE---------------
    let moviesWithEvents = []

    function findOcc(arr, key) {

        let arr2 = [];

        arr.forEach((x) => {

            // Checking if there is any object in arr2 
            // which contains the key value 
            if (arr2.some((val) => { return val[key] == x[key] })) {

                // If yes! then increase the occurrence by 1 
                arr2.forEach((k) => {
                    if (k[key] === x[key]) {
                        k["occurrence"]++
                    }
                })

            } else {
                // If not! Then create a new object initialize  
                // it with the present iteration key's value and  
                // set the occurrence to 1 
                let a = {}
                a[key] = x[key]
                a["occurrence"] = 1
                arr2.push(a);
            }
        })

        return arr2, moviesWithEvents.push(arr2)

    }



    /**----------CATCHING ERROR HERE IF CERTAIN BIOGRAF DOES NOT HAVE MOVIE ON SELECTED DATE---------- */
    useEffect(() => {
        if (cinemaIds.length && !ev.length) {
            setNoFilmError('ingen film hos valgte biograf i valget dato')
        }
        else setNoFilmError('')
    }, [cinemaIds, ev])

   
    useEffect(() => {
        if (regarr.length > 0 && !evs.length) {
            setNoFilmError('ingen film i valgte region')
        }
    }, [evs, regarr])


    /**------Gettting the filtered regions here ------------- */
    let filteredRegion = []  // contains filtered regions from choose region field
    regarr.forEach(checkReg);

    function checkReg(item) {
        allOrganizers.filter(org => {
            if (org.region == item) filteredRegion.push(org)
        })
    }
   
    allEvents.map(e => {
        filteredRegion.map(reg => {

            if ((reg._no === e._organizerNo)) {
                evs.push(e)       // evs contains events with filtered region and selected date      
            }
        })
    })
    let eventsWithReg = []
    allEvents.map(e => {
        filteredRegion.filter(reg => {
            if (reg._no === e._organizerNo) {
                eventsWithReg.push(e)
            }
        })
    })


    useEffect(() => {
        eventsWithReg && setFilteredEvents(eventsWithReg)  // adding filtered events with region
    }, [regarr])

    useEffect(() => {
        evs && setSortedEvents(evs)
    }, [selectedDate, regarr])
   


    /**-----GETTING FILTERED BIOGRAFS HERE------- */
    let filteredCinemas = []
    cinemaIds.forEach(checkCinemaIds)

    function checkCinemaIds(item) {
        allOrganizers.filter(org => {
            if (org._no === item) filteredCinemas.push(org)
        })
    }
  
    allEvents.map(event => {
        filteredCinemas.map(cinema => {
            if (event._organizerNo === cinema._no) {

                ev.push(event)
            }
        })
    })
    // map function below returns events with chosen cinema
    let eventsWithCinema = []
    allEvents.map(event => {
        filteredCinemas.map(cinema => {
            if (event._organizerNo === cinema._no) {

                eventsWithCinema.push(event)
            }
        })
    })

    useEffect(() => {
        eventsWithCinema && setFilteredEvents(eventsWithCinema)
    }, [cinemaIds])

    
    useEffect(() => {
        ev.length && setSortedEvents(ev)
    }, [cinemaIds, selectedDate])


    /**---- FILTERING FILM  WITH SELECTED DATE --- */
    let showsPerDay = []
   


    let eventsWithFilter = (cinemaIds.length || regarr.length) && sortedEvents.length ? sortedEvents : allEvents

   
    
    let eventsPerDay = []
    eventsWithFilter.map((e) => {
     
        if (selectedDate) {

            if (moment(e.dateTime).format('DD-MM-YYYY') === selectedDate) {
                allMovies.map((m) => {

                    if (m._no === e._movieNo) {

                        showsPerDay.push(m)
                        eventsPerDay.push(e)
                    }

                })
            }
        }
        else {

            allMovies.map((m) => {

                if (m._no === e._movieNo) {

                    showsPerDay.push(m)
                    eventsPerDay.push(e)
                }

            })
        }

    })
    let dates_array = eventsWithFilter.map((ev) => { return moment(ev.dateTime).format('DD-MM-YYYY') })



    findOcc(eventsPerDay, '_movieNo')  // findOcc function counts how many times a movie occurs in allEvents

    //find duplicates
    function toFindDuplicates(showsPerDay) {
        const uniqueElements = new Set(showsPerDay);

        showsPerDay.filter((item) => {
            if (uniqueElements.has(item)) {

            } else {
                return item;
            }
        });

        return [...new Set(uniqueElements)];
    }

    function toFindDuplicates(eventsWithFilter) {
        const uniqueElements = new Set(eventsWithFilter);

        eventsWithFilter.filter((item) => {
            if (uniqueElements.has(item)) {

            } else {
                return item;
            }
        });

        return [...new Set(uniqueElements)];
    }


    const showsToday = toFindDuplicates(showsPerDay) //USE SHOWS PER DAY WHEN DAY FILTERING IS MADE

    const datearr = toFindDuplicates(dates_array)


    useEffect(() => {
        appHeightChanged()
      
    })


    // ASSIGNING MOST PROGRAMMED IN ALLMOVIES
    allMovies.map((movie) => {
        moviesWithEvents[0].map((e) => {
            if (e._movieNo === movie._no) {
                Object.assign(movie, { most_programmed: e.occurrence })

            }
        })
    })

    // ----------ASSIGNING USEDCOUNT  INTO ALLEVENTS  WHICH IS TOTALCOUNT - FREECOUNT------------

    useEffect(() => {
        allEvents.map((event) => {
            locations.map((loc) => {


                if (event._locationNo === loc._no && loc._organizerNo === event._organizerNo) {
                    let c = loc.seats._totalCount
                    let v = event.seats._freeCount

                    let usedCount = c - v

                    Object.assign(event, { usedCount: usedCount })


                }

            })
        })
    }, [])



    // ----------SUMMING USEDCOUNT IN ALLEVENTS---------------
    useEffect(() => {
        let result = cinemaID ? (allEvents.filter((e) => { return e._organizerNo === cinemaID })) : allEvents.reduce((a, v) => {
            let obj = a.find(i => i._movieNo === v._movieNo)
            if (obj) {

                obj.usedCount += v.usedCount;
            } else {
                a.push(v);
            }
            return a;

        }, [])


        //------------ASSIGNING THE TOTAL OF USED COUNT IN ALLMOVIES -- calculate usedcount from event and sum those as per movie---------
        allMovies.map((movie) => {
            result.map((res) => {
                if (res._movieNo === movie._no) {
                    Object.assign(movie, { most_sold: res.usedCount })
                }

            })
        })

    })


    function handleArrrow() {
        setIsOpen((current) => !current);
    }

    function handleSort(item) {
        //console.log('handle clicked')
        setSortID(item.id)
        setSortedBy(item.name)
        setIsOpen(false)
        localStorage.setItem('sort_id', item.id)
        localStorage.setItem('sortedby', item.name)
    }



    // ----------FILTERING MOVIES WITH CHOOSE REGION----------------- 
    //  console.log(orgsPerRegion, 'orgs per region')
    let orgsArr = []



    useEffect(() => {
        orgsPerRegion && orgsPerRegion.map((org) => {
            // console.log(org._no)
            orgsArr.push(org._no)
        })
    },[])

    

    let arr = [];

    allOrganizers.filter((i) => arr.push(i.region))



    function movieId(id) {

        let mo = []
        showsToday.map(m => {
            if (m._no == id) {
                mo.push(m)

            }
        })
        return mo
    }

    //  console.log(selectedMovieId, 'select movie')

    let eventsWithMovieArr = []
    allEvents.map(ev => {
        let e

        if (ev._movieNo == selectedMovieId) {

            eventsWithMovieArr.push(ev)

        }

    })



    //const [selectedMovie, setSelectedMovie] = useState()
    function isEmpty(obj) {
        for (const prop in obj) {
            if (Object.hasOwn(obj, prop)) {
                return false;
            }
        }
        return true;
    }

    // assigning censor image to showsToday
    showsToday.map((movie) => {
        // if (movie.censoring) {
        let n = movie.censoring
        const mc = isEmpty(movie.censoring) === false ? _.find(ageCensor, (icon) => { return n.includes(icon.id) }) : null

        Object.assign(movie, { censorImage: isEmpty(movie.censoring) === false ? mc?.image : null })
        // }
    })

    //  assigning validShowtimes to showsToday
    // useEffect(() => { 
    showsToday.map((movie) => {

        Object.assign(movie, { validShowtimes: findShowtimes(movie._no) })
    })

    // }, [])


    function findShowtimes(movie_id) {
        //  console.log(movie_id, 'clicked movie id')
        let arr = []
        eventsWithFilter.map((event) => {

            if (event._movieNo == movie_id) {
                // console.log(event)
                arr.push(event)
            }

        })
        return arr
        //  console.log(arr, 'arr')
    }

   

    function handleMovieClick(e) {

        setSelectedMovieId(e.target.id)
        let movie_id = e.target.id
        let organizers = filteredRegion.length > 0 ? filteredRegion : allOrganizers
        let clickedMovie = movieId(movie_id)
        let showtimesPerFilm = findShowtimes(movie_id)

        const movieData = isBaseMovie(clickedMovie)
        // let filmDetailUrl = `${ROUTES.EBILLET_MOVIE_DETAILS}/${showtime.movieId}/${showtime.id}?org=${showtime.organizerId}`;
        movie_id && history.push(`/film-details?movieid=${movie_id}&sitetype=${site_type}`, { backTo})
    }

    function isBaseMovie(clickedMovie) {

        let movie_arr = []

        showsToday.map((movie) => {
            if (clickedMovie[0]._movieBaseNo > 0) {

                if (movie._movieBaseNo === clickedMovie[0]._movieBaseNo) {
                    movie_arr.push(movie)
                }
            }
            else if (movie._no === clickedMovie[0]._no) {
                movie_arr.push(clickedMovie[0])

            }
        })


        return movie_arr
    }

    function cancelAllFilters() {
        setCinemaarr([])
        setMoviearr([])
        setRegarr([])
        setSelectedDate()
    }
   
    const [oneOrgMovies, setOneOrgMovies] = useState()

    
    let movieFiletered = []
    useEffect(() => {
        setOneOrgMovies(showsToday.filter(show => moviearr.includes(show.name)))
    }, [moviearr])


    //console.log(oneOrgMovies)

    let showtimeTypes = [];

    showsToday.map((shows) => (
        shows.validShowtimes.map((showtime) => {
            if (showtime._eventTypeNo > 0) showtimeTypes.push(showtime._eventTypeNo)

        })

    ))

    // console.log(showtimeTypes)

    function toFindDuplicates(showtimeTypes) {
        const uniqueElements = new Set(showtimeTypes);

        showtimeTypes.filter((item) => {
            if (uniqueElements.has(item)) {

            } else {
                return item;
            }
        });

        return [...new Set(uniqueElements)];
    }
   

    const showsTypes = toFindDuplicates(showtimeTypes)
    
    //console.log(showsToday, 'shows today')



    let showtypes = []
    for (let i = 0; i < showsToday.length; i++) {
        let event = showsToday[i]
        event.validShowtimes.map((showtimes) => {
            
            if (showtimes._eventTypeNo > 0 && moment(showtimes.dateTime).format('DD-MM-YYYY') === selectedDate) {
               

                showtypes.push({
                    name: event.name,
                     showtime_types:  allEventsTypes.find((type) => { return type._no === showtimes._eventTypeNo })
                })

            }
        })

    }
   
   
  
    const showtypes_res = showtypes.reduce((a, b) => {
        const found = a.find(e => e.name == b.name);
        //console.log(found, 'found')
        return found ?  found.showtime_types.push(b.showtime_types) : a.push({ ...b, showtime_types: [b.showtime_types] }), a;
    }, [])

   

    let types_arr = []
    allEventsTypes.map((ev) => {
        for (let i = 0; i < showsTypes.length; i++) {
            if (ev._no === showsTypes[i])
            types_arr.push(ev)
        }
    })
    

    let showtypes_array = []
    showsToday.map((shows) => { 
        selectedDate && cinemaarr.length === 1 && showtypes.map((show, index) => {

            if (show.name === shows.name)
                showtypes_array.push({
                    typeNo: types_arr.findIndex(x => x.name === show.showtime_types.name) + 1,
                    typeName: show.showtime_types.name  })
              

        })
    })


  

    const [showItem, setShowItem] = useState(null);

    const menuClickHandler = (param) => {
        if (showItem === param) {
            setShowItem(null);
        } else {
            setShowItem(param);
        }
    };

  

    function returnName(name) {
        var arr = name.split("-");

        var firstVal = arr.join("-")
        return firstVal
    }
    
    function movieSubTitel(movie) {
        let sub_name
        if (movie._movieBaseNo > 0 && movie.name.includes('-')) {
            allMovieBases.map((base) => {
                if (base._no === movie._movieBaseNo) {
                   let   sub = movie.name.replace(base.name, '')
                    sub_name = sub.replace('-','')
                    return sub_name
                }
                return sub_name

            })
            return sub_name

        }
        return sub_name

    }
  
    function movieTitel(movie) {
        let name = movie.name
        if (movie._movieBaseNo > 0) {
            allMovieBases.map((base) => {
                if (base._no === movie._movieBaseNo) {
                    name = base.name
                   return name
                }
                return name

            })
            return name

        }
     return name
    }

  
    function handleClkOutside() {
       
        setShowItem(null)
        setIsOpen(false)
    }
   
    
    return (
        <> {
            showItem || isOpen ? 
                <div className="modal-backdrop" onClick={handleClkOutside}
                    style={{ top: '0px', width: '1920px', height: '100%', background:'transparent' }}
                >

                </div>
                : ''
        }
            
    {allMovies.length > 1 ? (

                <main className='AllMovies' >
                  
         <section className='header-section' >
             <div style={{position:'relative'}}>
                 <button onClick={cancelAllFilters} className='cancelAllFilters' >Nulstil filtre</button>
             
                 <div className='chooseFromContainer' >
                               

                    <Region showItem={showItem} menuClickHandler={menuClickHandler} allOrganizers={allOrganizers} setOrgPerRegion={setOrgPerRegion}
                                setResetCinema={setResetCinema} regarr={regarr} setRegarr={setRegarr}  showItem={showItem} menuClickHandler={menuClickHandler}/>

                     <Dates showItem={showItem} menuClickHandler={menuClickHandler}  datearr={datearr}  selectedDate={selectedDate} setSelectedDate={setSelectedDate} />

                     <Cinema showItem={showItem} menuClickHandler={menuClickHandler} allOrganizers={filteredRegion.length > 0 ? filteredRegion : allOrganizers} cinemaIds={cinemaIds} setCinemaIds={setCinemaIds}
                                setCinemaID={setCinemaID} resetCinema={resetCinema} setResetCinema={setResetCinema} regarr={regarr} cinemaarr={cinemaarr}
                                           setCinemaarr={setCinemaarr} />

                    <Films showItem={showItem} menuClickHandler={menuClickHandler}  films={showsToday} moviearr={moviearr} setMoviearr={setMoviearr} setRegarr={setRegarr} setCinemaIds={setCinemaIds}
                                           setCinemaarr={setCinemaarr} setCinemaID={setCinemaID} setSelectedDate={setSelectedDate} />
                               
                </div>
                           

             </div>
         </section>
         <br></br>
                   
        <section className='programFilmContainer'>

                       <div className='program-header'>
                            <p className='program'></p>

                            <div className='sorting' >
                                <svg style={{marginTop:'15px'}} width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.08 5.50024V16.64" stroke="white" stroke-width="2" stroke-linecap="round" />
                                    <line x1="1" y1="1" x2="16.52" y2="1" stroke="white" stroke-width="2" stroke-linecap="round" />
                                    <line x1="1" y1="6.40002" x2="11.12" y2="6.40002" stroke="white" stroke-width="2" stroke-linecap="round" />
                                    <line x1="1" y1="11.8" x2="7.04" y2="11.8" stroke="white" stroke-width="2" stroke-linecap="round" />
                                    <path d="M11.16 11.96L16.08 16.88L21 11.96" stroke="white" stroke-width="2" stroke-linecap="round" />
                                </svg>
                                <div className=''>
                                    <div className='sortingContainer' style={{
                                        borderBottomLeftRadius: isOpen ? '0px' : '8px',
                                        borderTopLeftRadius: '8px',
                                        borderTopRightRadius: '8px',
                                        borderBottomRightRadius: isOpen ? '0px' : '8px', boxShadow: '0px 5px 15px 0px rgba(0, 0, 0, 0.15)'
                                    }} >
                                        <div style={{
                                          //  padding: "5px 8px",
                                            boxSizing: "border-box",
                                            height: "50px",  boxShadow: '0px 5px 15px 0px rgba(0, 0, 0, 0.15)'
                                        }}>
                                            <p style={{
                                                margin: 0, paddingTop: '12px', paddingLeft: '16px', fontSize: '18px', fontWeight: 500, color: 'white',
                                                letterSpacing: '0.54px', fontFamily: "PP Neue Montreal",
                                            }}>{sortedBy}</p>
                                            
                                            <button 
                                                onClick={ () => handleArrrow()}
                                                style={{
                                                    position: "absolute", borderTopLeftRadius: '0px',
                                                    borderBottomLeftRadius: '0px',
                                                    bottom: "0px", borderTopRightRadius: '8px', borderBottomRightRadius:'8px',
                                                    right: "0px",
                                                    border: "none",
                                                    outline: "none",
                                                    backgroundColor: '#9D2D26',
                                                    width: '50px', height: '50px'
                                                }}
                                            >
                                                <p className={isOpen ? "rotate down" : "rotate "}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
                                                        <path d="M1.5 1L10 10L18.5 1" stroke= 'white' stroke-width="2" stroke-linecap="round" />
                                                    </svg>
                                                </p>
                                            </button>
                                        </div>

                                        {isOpen &&
                                            <div className="sortingDiv">
                                                {sorting && sorting.map((item) => (
                                                    <p key={item.id} id={item.id} style={{
                                                        height: '15px', fontSize: '18px', fontWeight: 500,color:'white',
                                                        letterSpacing: '0.54px',fontFamily: "PP Neue Montreal",
                                                    }} /*onChange={() => setSortID(item.id)}*/ onClick={() => handleSort(item)}>{item.name}</p>
                                                ))}

                                            </div>

                                        }
                                    </div>

                               </div>
                           </div>
                        </div>
                        <br></br>
                        {noFilmError ?  <p>{noFilmError}</p> : 
                       <div className='all-film-program' >

                                {/* oneOrgMovie films are filtered from alle film dropdown */}
                                {oneOrgMovies.length ? oneOrgMovies.map((item, index) => (
                                    <div className='film-program-item ' key={index}  >
                                        <div id={item._no} className='Poster' style={{ position: 'relative', }}>
                                            <img id={item._no} onClick={(item) => handleMovieClick(item)} style={{ width: '100%', borderRadius: '16px', height: '451px' }} src={'https://poster.ebillet.dk/' + `${item.largePath}`} alt="movie-banner" />
                                            <div className='age-banner poster-banner'> {isEmpty(item.censoring) === false ?
                                                <img className='' style={{ position: 'absolute', bottom: '10px', right: '15px' }} src={item.censorImage} alt='age-banner' /> : null}
                                            </div>
                                        </div>
                                        <div className='film-btn-container' >
                                            <p className='ellipsis-twoline'>{movieTitel(item)}</p>
                                            <p className='otherVersion'>{movieSubTitel(item)}</p>

                                            {selectedDate && cinemaarr.length === 1 ?
                                                <>
                                                    <div style={{ display: 'flex', rowGap: '16px', justifyContent: 'space-between', gap: '10px', flexWrap: 'wrap' }}>
                                                        {item.validShowtimes.map((shows) => (
                                                           
                                                            moment(shows.dateTime).format('DD-MM-YYYY') == selectedDate &&
                                                            <>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>

                                                                    <ShowtimeProgram showtime={shows} index={index} showsTimes={true} showsTypes={showsTypes}

                                                                        date_text={shows.dateTime.split('T')[1].slice(0, 5)} site_type={site_type} />

                                                            </div>
                                                               
                                                            </>
                                                        ))}


                                                    </div>

                                                </>
                                                :
                                                <button className='film-program-btn' id={item._no} onClick={(item) => handleMovieClick(item)}
                                                > Billetter</button>
                                            }
                                        </div>

                                    </div>

                                ))
                                    : showsToday.sort((a, b) => (sortID == 1 ? a.most_sold > b.most_sold ? -1 : 1 :
                                        sortID == 2 ? a.most_programmed > b.most_programmed ? -1 : 1 :
                                                    sortID == 3 ? moment(a.openingDate).format("YYYY-MM-DD") > moment(b.openingDate).format("YYYY-MM-DD") ? -1 : 1 
                                                    
                                                    : a.name > b.name ? 1 : -1))
                   
                                        .map((item, index) => (
                                                  
                                            item.name && isEmpty(item.largePath) === false &&
                                            <div className='film-program-item '  key={index}  >
                                                    <div id={item._no} className='Poster' style={{ position: 'relative', }}>
                                                        <img id={item._no} onClick={(item) => handleMovieClick(item)} style={{ width: '100%', borderRadius: '16px', height: '451px', boxShadow: '0px 5px 15px 0px rgba(0, 0, 0, 0.30)' }} src={'https://poster.ebillet.dk/' + `${item.largePath}`} alt="movie-banner" />
                                                        <div className='age-banner poster-banner'> {isEmpty(item.censoring) === false ?
                                                            <img className='' style={{ position: 'absolute', bottom: '10px', right: '15px' }} src={item.censorImage} alt='age-banner' /> : null}
                                                        </div>
                                                    </div>
                                                    <div className='film-btn-container' >
                                                        <p className='ellipsis-twoline'> {movieTitel(item)} </p>
                                                        <p className='otherVersion'> {movieSubTitel(item) } </p>
                                                       
                                                        {selectedDate && cinemaarr.length === 1 ?
                                                          <>
                                                            <div style={{ display: 'flex', rowGap:'16px', justifyContent: 'space-between', gap: '10px', flexWrap: 'wrap' }}>
                                                                    {item.validShowtimes.map((shows) => {

                                                                      
                                                                    
                                                                        return moment(shows.dateTime).format('DD-MM-YYYY') == selectedDate && <div style={{ display: 'flex', justifyContent: 'space-between' }}>

                                                                            <ShowtimeProgram showtime={shows} index={index} showsTimes={true} showtimeTypes={types_arr} site_type={site_type }
                                                                                date_text={shows.dateTime.split('T')[1].slice(0, 5)} />

                                                                            </div>



                                                                       
                                                                })}
                                                                   
                                                                   
                                                                </div>
                                                                
                                                              
                                                            </>  
                                                            : 
                                                            <button className='film-program-btn' id={item._no} onClick={(item) => handleMovieClick(item)} 
                                                            > Billetter</button>
                                                        }
                                                    </div>
                                                        <br></br>
                                                    {selectedDate && cinemaarr.length === 1 && showtypes_res.map((show, index) => {

                                                      return  show.name === item.name &&
                                                             
                                                          show.showtime_types.filter(
                                                              (value, index, self) =>
                                                                  index === self.findIndex((t) => t.name === value.name)
                                                          ).map((showtimes,index) => {

                                                               return <div style={{ color: 'white', position: 'relative', display: 'flex' }}>
                                                                   <span className='showtime-type-icon' style={{ left: 0 }}>{types_arr.findIndex(x => x.name === showtimes.name) + 1}</span>
                                                                   <p style={{ margin: 0, paddingLeft: '35px', paddingTop: '10px', letterSpacing:'0.42px' }}>{showtimes.name}</p>
                                                               </div>

                                                           }
                                                           )
                                                        
                                                           
                                                          
                                                            
                                                    })
                                                    }
                                            </div>
                                
                                        )) 
                                  
                                   
                           }
                           </div>
                       }
              </section>

                </main>
            )
                :
                <div className={`Spinner overlay ${allMovies ? ' fade-in' : ' fade-out'}`}>
                    <p className="overlay-content">Indlæser..........</p>
                </div>
            }


        </>
    )
}